import React, { useEffect, useState } from "react";
import { Reveal } from "@/components/Reveal";
import { getIcon } from "@/lib/icons";
import api from "@/lib/api";

export default function Activities() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/activities").then(({ data }) => setItems(data)).catch(() => {}); }, []);

  return (
    <div className="relative z-10 pt-28">
      <section className="mx-auto max-w-7xl px-5 py-12">
        <Reveal>
          <span className="text-xs uppercase tracking-[0.25em] font-semibold text-primary-c">Student Activities</span>
          <h1 className="font-display font-black text-5xl sm:text-6xl tracking-tighter text-t mt-4">Learning by <span className="text-primary-c">Doing.</span></h1>
          <p className="text-muted-c text-lg mt-5 max-w-2xl">Robotics, drones, 3D printing, VR, IoT and hands-on workshops — where our learners build real things and have real fun.</p>
        </Reveal>

        {items.length === 0 ? (
          <div className="glass rounded-2xl p-12 text-center text-muted-c mt-10">Activities coming soon.</div>
        ) : (
          <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3 mt-12">
            {items.map((a, i) => {
              const Icon = getIcon(a.icon);
              return (
                <Reveal key={a.id} delay={(i % 3) * 0.08}>
                  <div className="glass card-hover rounded-2xl overflow-hidden h-full flex flex-col" data-testid={`activity-${a.id}`}>
                    {a.imageUrl ? (
                      <img src={a.imageUrl} alt={a.title} loading="lazy" className="w-full h-44 object-cover" />
                    ) : (
                      <div className="w-full h-44 flex items-center justify-center" style={{ background: "rgba(var(--primary-rgb),0.1)" }}>
                        <Icon className="text-primary-c" size={48} />
                      </div>
                    )}
                    <div className="p-6 flex flex-col flex-1">
                      {a.category && <span className="text-[11px] uppercase tracking-wide font-semibold text-primary-c">{a.category}</span>}
                      <h3 className="font-display font-bold text-xl text-t mt-1">{a.title}</h3>
                      <p className="text-muted-c text-sm mt-2 flex-1">{a.description}</p>
                    </div>
                  </div>
                </Reveal>
              );
            })}
          </div>
        )}
      </section>
    </div>
  );
}
